import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

export function DemoSignup() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!email.trim()) {
      setSubmitMessage('Vennligst skriv inn en gyldig e-postadresse.');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      setSubmitMessage('Vennligst skriv inn en gyldig e-postadresse.');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage(null);

    try {
      const { error } = await supabase
        .from('demo_email_signups')
        .insert({
          email: email.trim().toLowerCase(),
          source: 'footer',
          status: 'pending'
        });

      if (error) {
        console.error('Error submitting email:', error);
        
        // Handle specific database constraint errors
        if (error.code === '23514' && error.message.includes('valid_email')) {
          setSubmitMessage('E-postadressen er ikke gyldig. Vennligst sjekk at den er skrevet riktig.');
        } else {
          setSubmitMessage('Noe gikk galt. Prøv igjen senere.');
        }
        return;
      }

      // Send notification email to admin
      try {
        console.log('Attempting to send admin notification...');
        const { data, error: notificationError } = await supabase.functions.invoke('send-demo-notification', {
          body: {
            email: email.trim().toLowerCase(),
            source: 'footer',
            created_at: new Date().toISOString()
          }
        });
        
        console.log('Notification response:', { data, error: notificationError });
        
        if (notificationError) {
          console.error('Failed to send notification:', notificationError);
          // Don't fail the main flow if notification fails
        } else {
          console.log('Admin notification sent successfully');
        }
      } catch (notificationError) {
        console.error('Failed to send notification:', notificationError);
        // Don't fail the main flow if notification fails
      }

      // Redirect to thanks page
      navigate('/takk');
    } catch (err) {
      console.error('Unexpected error:', err);
      setSubmitMessage('Noe gikk galt. Prøv igjen senere.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-condo-light text-condo-dark p-6 rounded-xl h-full">
      <div className="flex flex-col justify-evenly h-full">
        <h3 className="text-lg font-semibold">Liker du også demoversjonen?</h3>
        <p className="text-sm">
          Kontakt oss for å lære mer om hvordan Condo kan forbedre din bolig og bofellesskap.
        </p>
        <form onSubmit={handleEmailSubmit} className="flex gap-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Din e-post"
            className="flex-1 px-4 py-2 rounded-lg bg-white border border-gray-200 text-condo-dark placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-condo-dark"
            required
          />
          <button 
            type="submit"
            disabled={isSubmitting}
            className="px-4 py-2 bg-condo-dark text-white rounded-lg hover:bg-condo-med disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Sender...' : 'Send'}
          </button>
        </form>
        {submitMessage && (
          <p className="text-sm text-red-600 mt-2">{submitMessage}</p>
        )}
      </div>
    </div>
  );
}
